import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/hand-drawn-fire-prevention-concept_23-2149126371.jpg';

function DisasterResponseRecovery() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Disaster Response and Recovery Operations" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Disaster Response and Recovery Operations</h4>
              <p>
                This sub-department is focused on collaborating with agencies to provide effective disaster response and recovery services.<br />
                Initiatives include emergency management planning, resource distribution during crises, and post-disaster recovery programs to restore affected areas.<br /><br />
                By ensuring preparedness and fostering collaboration, we aim to minimize the impact of disasters and support community resilience.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Services</h3>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Emergency Management Planning</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Resource Distribution During Crises</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Post-Disaster Recovery Programs</h5>
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We are committed to safeguarding communities by ensuring readiness, providing swift responses, and facilitating recovery efforts during and after disasters.
              </p>
            </div>
            <div>
              <Link to="/department/public-safety">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default DisasterResponseRecovery;
